
// import React from 'react'
// import Image_1 from "../assets/Aboutus/Image_1.png";
// import PageLayout from '../components/navFoot/PageLayout';
// import RequestDemoNearFooter from '../components/LandingPage/RequestDemoNearFooter';

// const Aboutus = () => {
//   return (
//     <PageLayout>
//         <div style={{marginTop:'156px'}}>
//             <div style={{maxWidth:'1072px',height:'188px',display:'flex',flexDirection:'column',justifyContent:'space-between',textAlign:'center',margin:'auto'}}>
//                 <p style={{ textAlign: 'center', color: '#F6BE6B' }}>About Us</p>
//                     <p style={{ fontSize: '48px'}}>
//                         World’s best AI Productivity Tool backed by Multimodal Generative AI
//                     </p>
//             </div>
//             <div style={{maxWidth:'900px',height:'60px',margin:'80px auto'}}>
//                 <p style={{fontSize:'20px',color:'rgba(255,255,255,0.8)'}}>ModalX provides adaptability for your generative AI requirements by merging our array of cutting-edge open models with self-hosting advantages.</p>
//             </div>
//             <div style={{maxWidth:'900px',height:'60px',margin:'80px auto'}}>
//                 <p style={{fontSize:'20px',color:'rgba(255,255,255,0.8)'}}>We're not just AI; we're your AI running mate. ModalX is a multimodal platform that understands your business, predicts your challenges, and delivers tailored AI solutions. From strategy to execution, we've got you covered.</p>
//             </div>
//             <div style={{maxWidth:'1072px',maxHeight:'605px',margin:'80px auto'}}>
//                 <img src={Image_1}/>
//             </div>
//             <div>
//                 <p style={{fontSize:'48px',textAlign:'center'}}>About Our Team</p>
//                 <div style={{margin:'80px auto',maxWidth:'380px',height:'128px',display:'flex',justifyContent:'space-between',color:'rgba(255,255,255,0.9)'}}>
//                     <p style={{fontSize:'24px'}}>Founders</p>
//                     <div>
//                         <p>Jeremy Barber</p>
//                         <p>Hanif Joshaghani</p>
//                         <p>Peh Keong Teh</p>
//                         <p>Vikram Shekhawat</p>
//                     </div>
//                 </div>
//             </div>
//             <div>
//                 <RequestDemoNearFooter />
//             </div>
//         </div>
//     </PageLayout>
//   )
// }
// export default Aboutus

import React, { useState } from "react";
import {
  Box,
  Typography,
  useMediaQuery,
  Container,
  Grid,
  Card,
  Button,
  Chip,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  alpha,
  useTheme,
} from "@mui/material";
import {
    Flag,
  People,
  Favorite,
  FlashOn,
  Handshake,
  LinkedIn
} from "@mui/icons-material";
import Image_1 from "../assets/Aboutus/Image_1.png";
import PageLayout from "../components/navFoot/PageLayout";
import RequestDemoNearFooter from "../components/LandingPage/RequestDemoNearFooter";
import User1 from "../assets/LandingPage_Items/founder/image3.png";
import User2 from "../assets/LandingPage_Items/founder/image2.png";
import User3 from "../assets/LandingPage_Items/founder/image1.png";
import User4 from "../assets/LandingPage_Items/founder/image4.png";
import { useNavigate } from "react-router-dom";



const features = [
  {
    id: "1",
    image: User1,
    name: "Vikram Shekhawat",
    linkdin: "https://www.linkedin.com/in/vikramshekhawat/"
  },
  {
    id: "2",
    image: User2,
    name: "Peh Keong Teh",
    linkdin: "https://www.linkedin.com/in/peh-keong-teh-7899331b/"
  },
  {
    id: "3",
    image: User3,
    name: "Hanif Joshaghani",
    linkdin: "https://www.linkedin.com/in/hanif-joshaghani/"
  },
  {
    id: "4",
    image: User4,
    name: "Jeremy Barber",
    linkdin: "https://www.linkedin.com/in/jeremy-barber/"
  },
];

const stats = [
  { label: "Founded", value: "2024" },
  { label: "Team Size", value: "10+" },
  { label: "Countries", value: "2+" },
  { label: "AI Models", value: "30+" }
];

const values = [
  {
    title: "Human-Centric Innovation",
    description: "We design AI with people in mind—understanding your role, business, and goals instantly so you can benefit from smart, context-aware solutions that enhance productivity and creativity right from the start.",
    icon: People
  },
  {
    title: "Accessibility & Affordability",
    description: "ModalX brings AI to everyone—eliminating subscription fatigue and platform fragmentation—by delivering a powerful, unified platform that's as affordable and easy to use as talking to a friend.",
    icon: Favorite
  },
  {
    title: "Agile Empowerment",
    description: "We prioritize speed, adaptability, and experimentation—empowering small and medium teams to evolve quickly and creatively, shifting the AI adoption curve in their favor.",
    icon: FlashOn
  },
  {
    title: "Partnership Mindset",
    description: "ModalX is more than a tool—it's your AI business partner. Through features like Agent Vic, we support research, brainstorming, execution, and everything in between—so AI becomes an intelligent teammate, not just a feature.",
    icon: Handshake
  }
];

const team = [
  {
    name: "Vikram Shekhawat",
    role: "ABC",
    bio: [
      "MBA / 4x Co-Founder",
      "CRO at Pariksha (India's largest test prep platform with 6M+ users)",
      "CEO - Bschool.co",
      "Co-Founder - Crushaider",
      "Ex Zonal Head Times, HDFC Bank, Kotak Mahindra Bank"
    ],
    image: User1
  },
  {
    name: "Deepak Choudhary",
    role: "ABC",
    bio: [
      "2x Co-Founder",
      "Director Engineering-Murf Al (Raised 10 Million USD)",
      "CTO at Pariksha (India's largest test prep platform with 6M+ users)",
      "B.Tech from IIT Kanpur - India's top ranked tech college"
    ],
    image: User2
  },
  {
    name: "Peh Keong Teh",
    role: "ABC",
    bio: [
      "Previously President & CPO of Symend",
      "SVP Cloud @ Salesforce",
      "Product Lead, Cloud @ Oracle",
      "Principal Azure @ Microsoft"
    ],
    image: User2
  },
  {
    name: "Jeremy Barber",
    role: "ABC",
    bio: [
      "2x Venture Studio Founder",
      "Builder of Neo Financial and Amplifier Health",
      "4x Exited Founder"
    ],
    image: User4
  }
];

 const timelineData = [
    { year: "2024", title: "Concept Validation, June", description: "Validated our AI democratization concept with early market research and user interviews." },
    { year: "2024", title: "MVP Launch, October", description: "Released our minimum viable product to test core AI platform functionality." },
    { year: "2024", title: "Beta Launch, December", description: "Launched beta version with select users to gather feedback and iterate on features." },
    { year: "2025", title: "Feature Addition, March", description: "Expanded platform capabilities with advanced AI tools and enhanced user experience." },
    { year: "2025", title: "Full Product Launch", description: "Official launch of ModalX platform with complete AI suite and Agent Vic integration." },
    { year: "2025", title: "Fundraise", description: "Securing strategic funding to accelerate growth and expand our AI capabilities globally." }
  ];

const Aboutus = () => {
  const isBelow991 = useMediaQuery("(max-width:991px)");
  const isBelow1200 = useMediaQuery("(max-width:1200px)");
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleBoxes = 3; // Number of boxes visible at once
  const boxWidth = 386;
  const theme = useTheme();
  const navigate = useNavigate();

  const handleLinkedinClick = (feature) => {
    if (feature?.linkdin) {
      window.open(feature.linkdin, "_blank");
    } else {
      console.error("LinkedIn link is missing");
    }
  };
  
  return (
    <PageLayout>
      {/* 
      <Box sx={{ marginTop: isBelow991 ? "80px" : "156px" }}>
        <Box
          sx={{
            maxWidth: "1072px",
            height: "188px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textAlign: "center",
            margin: "auto",
            width: isBelow991 ? "90%" : "100%",
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              color: "#F6BE6B",
              fontSize: isBelow991 ? "12px" : "16px",
            }}
          >
            About Us
          </Typography>
          <Typography sx={{ fontSize: isBelow991 ? "28px" : "48px" }}>
            World’s best AI Productivity Tool backed by Multimodal Generative AI
          </Typography>
        </Box>
        <Box
          sx={{
            maxWidth: "900px",
            height: "60px",
            margin: isBelow991 ? "60px auto" : "80px auto",
            width: isBelow991 ? "80%" : "100%",
          }}
        >
          <Typography
            sx={{
              fontSize: isBelow991 ? "16px" : "20px",
              color: "rgba(255,255,255,0.8)",
            }}
          >
            ModalX provides adaptability for your generative AI requirements by
            merging our array of cutting-edge open models with self-hosting
            advantages.
          </Typography>
        </Box>
        <Box
          sx={{
            maxWidth: "900px",
            height: "60px",
            margin: "80px auto",
            width: isBelow991 ? "80%" : "100%",
          }}
        >
          <Typography
            sx={{
              fontSize: isBelow991 ? "16px" : "20px",
              color: "rgba(255,255,255,0.8)",
            }}
          >
            We're not just AI; we're your AI running mate. ModalX is a
            multimodal platform that understands your business, predicts your
            challenges, and delivers tailored AI solutions. From strategy to
            execution, we've got you covered.
          </Typography>
        </Box>
        <Box
          sx={{
            maxWidth: "1072px",
            maxHeight: "605px",
            margin: isBelow991 ? "60px auto" : "80px auto",
            width: isBelow991 ? "80%" : "100%",
            paddingTop: "60px",
          }}
        >
          <img
            src={Image_1}
            alt="About Us"
            style={{ width: "100%", height: "auto" }}
          />
        </Box>
        <Box>
          <Typography
            sx={{ fontSize: isBelow991 ? "28px" : "48px", textAlign: "center" }}
          >
            About Our Team
          </Typography>
          <Box
            sx={{
              margin: isBelow991 ? "60px auto 120px auto" : "80px auto",
              maxWidth: "1140px",
              // height: "316px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "rgba(255,255,255,0.9)",
              width: isBelow991 ? "80%" : "100%",
            }}
          >
            <Typography
              sx={{
                fontSize: isBelow991 ? "20px" : "24px",
                fontFamily: "Inter",
                fontWeight: 600,
                fontStyle: "normal",
                lineHeight: "36px",
                color: "rgba(255, 255, 255, 0.90)",
              }}
            >
              Founders
            </Typography>
            <Box>
              <Box
                display="flex"
@@ -281,7 +391,321 @@ const Aboutus = () => {
@@ -281,7 +391,321 @@ const Aboutus = () => {
        <Box>
          <RequestDemoNearFooter />
        </Box>
      </Box> */}
        <Box sx={{ minHeight: "100vh", }}>
        {/* Hero Section */}
        <Box sx={{ pt: 20, pb: 20, px: 2 }}>
          <Container maxWidth="md" sx={{ textAlign: "center" }}>
            {/* <Chip
              label="About Modal"
              sx={{
                mb: 4,
                bgcolor: alpha("#f6be6b", 0.1),
                color: "#f6be6b",
                border: `1px solid #f6be6b`
              }}
            /> */}
            <Typography
              variant="h2"
              sx={{
                mb: 4,
                fontSize: { xs: "2.5rem", md: "4.5rem" },
                fontWeight: 700,
                background: `linear-gradient(to right, ${"#f2f2f2"}, ${"#a6a6a6"})`,
                // background: `linear-gradient(to right, #f2f2f2)`,
                backgroundClip: "text",
                textFillColor: "transparent",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent"
              }}
            >
              Building the Future of AI
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 6,
                color: "#a6a6a6",
                lineHeight: 1.6
              }}
            >
              We're democratizing access to the world's most powerful AI capabilities.
              Our mission is to make artificial intelligence simple, fast, and affordable for everyone.
            </Typography>

            <Grid container spacing={4} sx={{ mt: 8 }}>
              {stats.map((stat, index) => (
                <Grid item xs={6} md={3} key={index}>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="h4" sx={{ fontWeight: 700, color: "#f6be6b", mb: 1 }}>
                      {stat.value}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#a6a6a6" }}>
                      {stat.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* Mission Section */}
        <Box sx={{ py: 12, px: 2 }}>
          <Container maxWidth="lg">
            <Grid container spacing={8} alignItems="center">
              <Grid item xs={12} md={6}>
                <Typography variant="h3" sx={{ fontWeight: 700, mb: 4, color:"#f2f2f2" }}>
                  Our Mission
                </Typography>
                <Typography variant="h6" sx={{ color: "#a6a6a6", mb: 4, lineHeight: 1.6 }}>
                  To democratize enterprise-grade AI—by uniting the most powerful LLMs, generative tools, and intelligent agents into one seamless, user-friendly platform. We empower startups and SMEs across North America to tackle real business challenges with extraordinary efficiency and creativity, integrating AI into existing workflows without disruption.
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card sx={{ p: 4, bgcolor: "#1a1e34", border: `1px solid rgba(255, 255, 255, 0.1)`,borderRadius:"8px" , boxShadow: theme.shadows[4] }}>
                  <Box sx={{ mb: 4, display: "flex", justifyContent: "center" }}>
                    <Flag sx={{ width: 64, height: 64, color: "#f6be6b" }} />
                  </Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, mb: 3, color:"#f2f2f2" }}>
                    Our Vision
                  </Typography>
                  <Typography variant="body1" sx={{ color: "#a6a6a6" }}>
                    We're shaping a future where AI doesn't just understand—it thinks, ideates, and executes with human-like ingenuity. At ModalX, we envision AI as a creative business co-founder—accessible, intuitive, and transformative—enabled through Agent Vic to bring seamless, intelligent collaboration to businesses of all sizes across industries.
                  </Typography>
                </Card>
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* Values Section */}
        <Box sx={{ py: 12, px: 2 }}>
          <Container maxWidth="lg">
            <Box sx={{ textAlign: "center", mb: 8 }}>
              <Typography variant="h3" sx={{ fontWeight: 700, mb: 4  }}>
                Our Values
              </Typography>
              <Typography variant="h6" sx={{ color: "#a6a6a6", maxWidth: 600, mx: "auto" }}>
                These principles guide everything we do, from product development to customer support.
              </Typography>
            </Box>

            <Grid container spacing={4}>
              {values.map((value, index) => {
                const IconComponent = value.icon;
                return (
                  <Grid item xs={12} md={6} key={index}>
                    <Card sx={{
                      p: 4,
                      bgcolor: "#1a1e34",
                      border: `1px solid rgba(255, 255, 255, 0.1)`,
                      textAlign: "center",
                      transition: "all 0.3s ease",
                      borderRadius:"8px",
                      height:"290px",
                      "&:hover": {
                        boxShadow: `0 0 20px ${alpha("#f6be6b", 0.2)}`
                      }
                    }}>
                      <Box sx={{ mb: 3, display: "flex", justifyContent: "center" }}>
                        <IconComponent sx={{ width: 40, height: 40, color: "#f6be6b" }} />
                      </Box>
                      <Typography variant="h5" sx={{ fontWeight: 700, mb: 3, color:"#f2f2f2" }}>
                        {value.title}
                      </Typography>
                      <Typography variant="body1" sx={{ color: "#a6a6a6", lineHeight: 1.6 }}>
                        {value.description}
                      </Typography>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Container>
        </Box>

        {/* Team Section */}
        <Box sx={{ py: 12, px: 2 }}>
          <Container maxWidth="lg">
            <Box sx={{ textAlign: "center", mb: 8 }}>
              <Typography variant="h3" sx={{ fontWeight: 700, mb: 4, color:"#f2f2f2" }}>
                Meet Our Team
              </Typography>
              <Typography variant="h6" sx={{ color: "#a6a6a6", maxWidth: 600, mx: "auto" }}>
                We're a diverse group of engineers, researchers, and builders united by our passion
                for making AI more accessible.
              </Typography>
            </Box>

            <Grid container spacing={4}>
              {team.map((member, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card sx={{
                    p: 3,
                    bgcolor: "#1a1e34",
                    border: `1px solid rgba(255, 255, 255, 0.1)`,
                    textAlign: "center",
                    transition: "all 0.3s ease",
                    borderRadius:"8px",
                    height:"465px",
                    "&:hover": {
                      boxShadow: `0 0 20px ${alpha("#f6be6b", 0.2)}`
                    }
                  }}>
                    <Box sx={{ mb: 3, display: "flex", justifyContent: "center" }}>
                      <Avatar
                        src={member.image}
                        alt={member.name}
                        sx={{ width: 80, height: 80, border: `2px solid ${alpha("#f6be6b", 0.2)}` }}
                      />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, color:"#f2f2f2" }}>
                      {member.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#f6be6b", mb: 3 }}>
                      {member.role}
                    </Typography>
                    <List dense>
                      {member.bio.map((point, pointIndex) => (
                        <ListItem key={pointIndex} sx={{ px: 0, py: 0.5 }}>
                          <ListItemIcon sx={{ minWidth: 24, color: "#f6be6b" }}>
                            •
                          </ListItemIcon>
                          <ListItemText primary={point} sx={{ m: 0 }} primaryTypographyProps={{ variant: "body2", color: "#a6a6a6" }} />
                        </ListItem>
                      ))}
                    </List>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* Timeline Section */}
        <Box sx={{ py: 12, px: 2  }}>
          <Container maxWidth="md">
            <Box sx={{ textAlign: "center", mb: 8 }}>
              <Typography variant="h3" sx={{ fontWeight: 700, mb: 4, color:"#f2f2f2" }}>
                Our Journey
              </Typography>
              <Typography variant="h6" sx={{ color: "#a6a6a6" }}>
                From a small research project to powering AI applications worldwide.
              </Typography>
            </Box>

            <Box sx={{ position: "relative" }}>
              {timelineData.map((milestone, index, array) => (
                <Box key={index} sx={{ position: "relative" }}>
                  {/* Connecting line */}
                  {index < array.length - 1 && (
                    <Box
                      sx={{
                        position: "absolute",
                        left: 32,
                        top: 64,
                        width: 2,
                        height: 64,
                        background: `linear-gradient(to bottom, ${"#f6be6b"}, ${alpha("#f6be6b", 0.3)})`
                      }}
                    />
                  )}

                  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 4, "&:hover": { color: "#f6be6b" } }}>
                    <Box sx={{ position: "relative", flexShrink: 0 }}>
                      <Box
                        sx={{
                          width: 64,
                          height: 64,
                          bgcolor: "#f6be6b",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#000000",
                          fontWeight: 700,
                          transition: "all 0.5s ease",
                          "&:hover": {
                            transform: "scale(1.1)",
                            boxShadow: `0 0 20px ${alpha("#f6be6b", 0.5)}`
                          },
                          animation: "fadeIn 0.5s ease",
                          animationDelay: `${index * 200}ms`,
                          animationFillMode: "both"
                        }}
                      >
                        {milestone.year.slice(-2)}
                      </Box>
                      <Box
                        sx={{
                          position: "absolute",
                          inset: 0,
                          width: 64,
                          height: 64,
                          bgcolor: alpha("#f6be6b", 0.2),
                          borderRadius: "50%",
                          scale: 0,
                          zIndex: -1,
                          transition: "transform 0.5s ease",
                          "&:hover": {
                            scale: 1.5
                          }
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        flex: 1,
                        pb: 6,
                        animation: "fadeIn 0.5s ease",
                        animationDelay: `${index * 200 + 100}ms`,
                        animationFillMode: "both"
                      }}
                    >
                      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2,transition: "color 0.3s ease" }}>
                        {milestone.title}
                      </Typography>
                      <Typography variant="body1" sx={{ color: "#a6a6a6", transition: "color 0.3s ease" }}>
                        {milestone.description}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </Container>
        </Box>

        {/* CTA Section */}
        <Box sx={{ py: 12, px: 2 }}>
          <Container maxWidth="md" sx={{ textAlign: "center" }}>
            <Typography variant="h3" sx={{ fontWeight: 700, mb: 4 , color:"#f2f2f2", }}>
              Join Our Mission
            </Typography>
            <Typography variant="h6" sx={{ color: "#a6a6a6", mb: 6 }}>
              We're always looking for talented individuals who share our passion for AI and innovation.
            </Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, justifyContent: "center" }}>
              <Button onClick={()=>{ navigate('/career')}} variant="contained" size="large" sx={{bgcolor:"#f6be6b", fontWeight:600,  borderRadius:"12px", color:"#000000", "&:hover":{ backgroundColor: "#ffd9aa", }}}>
                View Open Positions
              </Button>
              <Button onClick={()=> {navigate('/contact')}}  variant="outlined" size="large" sx={{color:"#f6be6b",fontWeight:600, border:"1px solid #f6be6b", borderRadius:"12px","&:hover":{border:"1px solid #f6be6b",  backgroundColor: "#282D51"}}}>
                Contact Us
              </Button>
            </Box>
          </Container>
        </Box>
      </Box>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </PageLayout>
  );
};

export default Aboutus;